import axios from '@/utils/request'
var Qs = require('qs')

export default {
    states: ['applying', 'pushing', 'picking', 'outed', 'cancel', 'ined', 'rejected',],
    // 2020-09-12
    search(params) {
        return axios.get('/allocates', params)
    },
    // 2020-11-18
    applyIn(params) {
        return axios.put('/allocates/apply-in', params)
    },
    // 2020-11-18
    applyOut(params) {
        return axios.put('/allocates/apply-out', params)
    },
    // 2021-03-23
    applyOutAndPick(params) {
        return axios.put('/allocates/apply-out-and-pick', params)
    },
    // 2020-11-19
    batchApplyIn(params) {
        return axios.put('/allocates/batch-apply-in', params)
    },
    // 2020-09-12
    update(id, params) {
        return axios.put('/allocates/' + id, params)
    },
    // 2020-09-12
    delete(id) {
        return axios.delete('/allocates/' + id)
    },
    // 2020-11-19
    unacceptSumByProductInfo(params) {
        return axios.get('/allocates/unaccept-sum-by-product-info', params)
    },
    // 2020-11-18
    agree(id, params) {
        return axios.put('/allocates/' + id + '/agree', params)
    },
    // 2021-03-23
    agreeAndPick(id, params) {
        return axios.put('/allocates/' + id + '/agree-and-pick', params)
    },

    // 2021-05-26
    batchAgree(params) {
        return axios.put('/allocates/batch-agree', params)
    },
    // 2021-05-26
    batchAgreeAndPick(params) {
        return axios.put('/allocates/batch-agree-and-pick', params)
    },
    // 2020-09-13
    reject(id, params) {
        return axios.put('/allocates/' + id + '/reject', params)
    },
    // 2021-03-18
    cancel(id, params) {
        return axios.put('/allocates/' + id + '/cancel', params)
    },
    // 2020-09-13
    exportExcel(params) {
        return axios.get('/allocates/export-excel?' + Qs.stringify(params, { arrayFormat: 'repeat' }))
    },
    // 2020-11-28
    pendingAgreeCount(params) {
        return axios.get('/allocates/pending-agree-count', params)
    },

}
